module.exports = __WEBPACK_EXTERNAL_MODULE_139__;


//////////////////
// WEBPACK FOOTER
// external "@jupyter-widgets/base"
// module id = 139
// module chunks = 0